import Modal from "common/Modal/Modal.tsx";
import PayoutMethods from "features/payouts/PayoutMethods/PayoutMethods.tsx";
import {
  LanguageNameSpaces,
  PayoutMethod,
  PayoutMethodSource,
} from "@shared/types";
import React from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import useMedia from "utils/hooks/useMedia.ts";
import { MOBILE_SEARCH } from "common/constants.ts";
import { useTheme } from "styled-components";

interface PayoutMethodsModalProps {
  open: boolean;
  closeModal: () => void;
  payoutMethods?: PayoutMethod[];
  source: PayoutMethodSource;
  loading?: boolean;
}

const PayoutMethodsModal = ({
  open,
  closeModal,
  payoutMethods,
  source,
  loading,
}: PayoutMethodsModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PAYOUTS);
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { isNewLook } = useTheme();
  // New look: the list starts 16px under the title, like the other modals.
  const bodyPadding = isMobile ? 16 : 24;

  return (
    <Modal
      title={t("payouts.my_payout_methods")}
      open={open}
      onCancel={closeModal}
      width={500}
      styles={{
        body: {
          padding: isNewLook
            ? `12px ${bodyPadding}px ${bodyPadding}px`
            : bodyPadding,
        },
      }}
    >
      <PayoutMethods
        payoutMethods={payoutMethods}
        source={source}
        inModal={true}
        loading={loading}
      />
    </Modal>
  );
};

export default PayoutMethodsModal;
